import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from '../../css/rulesAndPolicy.module.css';
import Bars from '../Bars';
import { FiArrowLeft } from 'react-icons/fi';

const HowItWorks = () => {
  return (
    <>
      <NavLink to="/info" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>

      <div className={`${styles.rulesAndPolicyConteiner} userSelectNone`}>
        <h3 className='h3-header' aria-label="Jak działa GórskaPodwózka">
          <img src="/logo/logoApp.png" alt="logo" className='logo' /> Jak działa GórskaPodwózka
        </h3>

          <p>🏔️ GórskaPodwózka to darmowa i prosta platforma ogłoszeń umożliwiająca wspólne podróże i wyprawy w góry oraz sprawdzenie pogody — bez logowania i rejestracji, bez opłat, szybko i wygodnie.</p>

          <p>🚗 Dodawanie <strong>przejazdów</strong>: podajesz miasto startowe, końcowe, (opcjonalnie miasta pośrednie), daty, zdjęcie, swoje imię i dane kontaktowe: telefon, Instagram lub Messenger (przynajmniej jeden sposób kontaktu).</p>
          <p>🥾 Dodawanie <strong>wypraw górskich</strong>: cel wędrówki (opcjonalnie miejsce startu), czas, zdjęcie, tempo wędrówki oraz imię i dane kontaktowe (przynajmniej jeden sposób kontaktu).</p>
          <p>🔍 Wyszukiwanie przejazdów: wyszukujesz przejazdy w określonym promieniu od wybranego miasta, a system pokazuje najbliższe.</p>
          <p>🔍 Wyszukiwanie wypraw: proste wyszukiwanie szlaków, znanych szczytów (np. Rysy) lub ciekawych miejsc.</p>
          <p>🔄 Można łatwo przełączać między panelem przejazdów a panelem wypraw za pomocą przycisków.</p>
          <p>🌤️ Pogoda: serwis korzysta z Open Meteo, prezentując prognozy dla znanych szczytów i wielu miejscowości. Informacje mają charakter poglądowy.</p>
          <p>📝🚫 Brak logowania, brak rejestracji, brak plików cookies – wszystko jest darmowe.</p>
          <p>☕ Wsparcie serwisu: użytkownicy mogą dobrowolnie „postawić kawę” twórcy, aby wspomóc rozwój platformy.</p>
          <p>🔒 Bezpieczeństwo: serwis nie pośredniczy w przejazdach ani wyprawach. Każdy odpowiada za swoje bezpieczeństwo i prawidłowość danych.</p>

          <p>🏔️ Celem GórskaPodwózka jest ułatwienie wspólnych podróży i wypraw w góry w sposób prosty, przejrzysty, bezpieczny i darmowy — bez zbędnych formalności.</p>

      </div>

      <p className='mycopyright userSelectNone'>
        © 2025 GórskaPodwózka — wszystkie prawa zastrzeżone, autor: Mateusz.
      </p>

      <Bars />
    </>
  );
};

export default HowItWorks;
